export default "__VITE_ASSET__BLeAkYMz__"